exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.form-item-member__wrap[data-v-d65e3d38] {\n  display: block;\n}\n.word-break[data-v-d65e3d38] {\n  word-break: break-all;\n}\n.wrap-text[data-v-d65e3d38] {\n  white-space: pre-line;\n  word-break: break-all;\n}\n", ""]);

// exports
